import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Col, Spacer, View } from '@amzn/stencil-react-components/layout';
import { Expander } from '@amzn/stencil-react-components/expander';
import { Hr } from '@amzn/stencil-react-components/layout';
import { InputWrapper } from '@amzn/stencil-react-components/input';
import { Text } from '@amzn/stencil-react-components/text';
import { TextArea } from '@amzn/stencil-react-components/text-area';
import BorderedView from '../common/BorderedView';
import isEmpty from 'lodash/isEmpty';
import { createContentSelector, templateContentSelector } from '../../selectors/selectors';
import {
  updateContentId,
  updateMessageContent,
  updateTemplateSubject,
} from '../../actions/nudgeActions';
import { BACKSPACE_KEY_CODE, DELETE_KEY_CODE } from '../../constants/editorConfig';
import { FormattedMessage, useIntl } from 'react-intl';

export const ContentPanel = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const contentElements = useSelector(templateContentSelector);
  const { selectedContentId, subject } = useSelector(createContentSelector);
  const [templateSubject, setTemplateSubject] = useState(subject);

  const deleteHandler = event => {
    const keyCode = event?.keyCode;
    if (keyCode === BACKSPACE_KEY_CODE || keyCode === DELETE_KEY_CODE) {
      const index = contentElements?.findIndex(element => element.id === selectedContentId);
      const updatedContentElements = [...contentElements];
      if (index > -1) {
        updatedContentElements.splice(index, 1);
      }
      dispatch(updateMessageContent(updatedContentElements));
    }
  };

  const updateSubject = event => {
    setTemplateSubject(event?.currentTarget?.value);
    dispatch(updateTemplateSubject(event?.currentTarget?.value));
  };

  useEffect(
    () => {
      setTemplateSubject(subject);
    },
    [subject],
  );

  return (
    <BorderedView
      flexDirection="column"
      display="flex"
      backgroundColor="white"
      flex="55%"
      style={{ overflow: 'auto' }}
      padding={'10px'}
    >
      <Expander
        titleText={formatMessage({
          id: 'app.contentPanel.label.subjectTitle',
          defaultMessage: 'Subject',
        })}
        isExpanded={true}
      >
        <Col>
          <InputWrapper
            id="input-id-1"
            labelText={formatMessage({
              id: 'app.contentPanel.label.emailSubject',
              defaultMessage: 'Email subject',
            })}
          >
            {inputProps => (
              <TextArea
                onChange={e => updateSubject(e)}
                data-testid="subject-textarea-id"
                height={45}
                resize="both"
                value={templateSubject}
                {...inputProps}
              />
            )}
          </InputWrapper>
        </Col>
      </Expander>
      <Hr />
      <Spacer height={10} />
      <Expander
        titleText={formatMessage({
          id: 'app.contentPanel.label.contentTitle',
          defaultMessage: 'Content',
        })}
        isExpanded={true}
        shouldExpandOnMount
      >
        <Col>
          <View
            id="content-textarea-id"
            data-testid="form-element"
            height={465}
            alignItems="center"
            css={() => {}}
          >
            <div
              className="content-styles"
              style={{ maxWidth: '700px', overflow: 'auto' }}
              data-testid="content-box"
            >
              {contentElements?.map(contentElement => {
                const isSelectedContent = contentElement.id === selectedContentId;

                return (
                  <div
                    className={'default ' + (isSelectedContent ? 'selected-content' : '')}
                    dangerouslySetInnerHTML={{ __html: contentElement?.content }}
                    onClick={() => {
                      dispatch(updateContentId(contentElement.id));
                    }}
                    key={contentElement.id}
                    tabIndex="0"
                    onKeyDown={event => deleteHandler(event)}
                  />
                );
              })}
            </div>
            {isEmpty(contentElements) ? (
              <Col
                justifyContent="center"
                alignItems="center"
                height={'100%'}
                width={'100%'}
                flex={1}
              >
                <Text color="gray">
                  <FormattedMessage id="app.contentPanel.label.pickElement" />
                </Text>
              </Col>
            ) : null}
          </View>
        </Col>
      </Expander>
      <Hr />
    </BorderedView>
  );
};
